
jQuery(document).ready(function(){

 if (document.querySelector('.bold_customer_id') !== null) {
   // $(".header__inline-menu ul li:nth-child(3)").show();
   console.log("yes");
   $(".register_btn").remove();
}
  else{
    // $(".header__inline-menu ul li:nth-child(3)").remove();
  }

});


$(document).ready(function() {
   $(".unit_picker label").each(function() {
    var text = $(this).text();
    var number = parseInt(text);
    $(this).text(number.toFixed(0));
  });
});